import { createAction } from '@ngrx/store';

export const loadDropDownData = createAction('[UserForm] loadDropDownData');
